import { render, staticRenderFns } from "./addPrioritySubmit.vue?vue&type=template&id=e47edce2&scoped=true&"
import script from "./addPrioritySubmit.vue?vue&type=script&lang=js&"
export * from "./addPrioritySubmit.vue?vue&type=script&lang=js&"
import style0 from "./addPrioritySubmit.vue?vue&type=style&index=0&id=e47edce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e47edce2",
  null
  
)

export default component.exports